import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';

const EMPTY = { name:'', address:'', phone:'', email:'' };

export default function Stores() {
  const [stores, setStores] = useState([]);
  const [modal, setModal]   = useState(false);
  const [form, setForm]     = useState(EMPTY);
  const [editing, setEditing] = useState(null);
  const [saving, setSaving]   = useState(false);

  const load = useCallback(() => {
    axios.get('/api/stores').then(r => setStores(r.data.stores || r.data));
  }, []);

  useEffect(() => { load(); }, [load]);

  const openNew  = () => { setForm(EMPTY); setEditing(null); setModal(true); };
  const openEdit = s => { setForm({ name:s.name, address:s.address||'', phone:s.phone||'', email:s.email||'' }); setEditing(s.id); setModal(true); };
  const closeModal = () => setModal(false);

  const save = async e => {
    e.preventDefault(); setSaving(true);
    try {
      if (editing) { await axios.put(`/api/stores/${editing}`, form); toast.success('Store updated'); }
      else         { await axios.post('/api/stores', form); toast.success('Store created'); }
      closeModal(); load();
    } catch (err) { toast.error(err.response?.data?.error || 'Save failed'); }
    finally { setSaving(false); }
  };

  const remove = async id => {
    if (!window.confirm('Delete this store?')) return;
    try { await axios.delete(`/api/stores/${id}`); toast.success('Deleted'); load(); }
    catch { toast.error('Failed'); }
  };

  return (
    <div>
      <div className="page-header">
        <div><h1>Stores</h1><p>Manage store locations</p></div>
        <button className="btn btn--primary" onClick={openNew}>+ Add Store</button>
      </div>

      <div className="card">
        <div className="table-wrap">
          <table>
            <thead><tr><th>Name</th><th>Address</th><th>Phone</th><th>Orders</th><th>Drivers</th><th>Actions</th></tr></thead>
            <tbody>
              {stores.map(s => (
                <tr key={s.id}>
                  <td><strong>{s.name}</strong></td>
                  <td>{s.address || '—'}</td>
                  <td>{s.phone || '—'}</td>
                  <td>{s.total_orders ?? 0}</td>
                  <td>{s.driver_count ?? 0}</td>
                  <td style={{ display:'flex', gap:8 }}>
                    <button className="btn btn--ghost btn--sm" onClick={() => openEdit(s)}>Edit</button>
                    <button className="btn btn--danger btn--sm" onClick={() => remove(s.id)}>Delete</button>
                  </td>
                </tr>
              ))}
              {stores.length === 0 && <tr><td colSpan={6}><div className="empty-state"><div className="icon">🏪</div>No stores found</div></td></tr>}
            </tbody>
          </table>
        </div>
      </div>

      {modal && (
        <div className="modal-backdrop" onClick={e => e.target === e.currentTarget && closeModal()}>
          <div className="modal">
            <h2>{editing ? 'Edit Store' : 'Add Store'}</h2>
            <form onSubmit={save}>
              {[['name','Store Name','text',true],['address','Address','text',false],['phone','Phone','tel',false],['email','Email','email',false]].map(([f,l,t,r]) => (
                <div className="form-field" key={f}>
                  <label>{l}{r && ' *'}</label>
                  <input className="form-control" type={t} required={r} value={form[f]}
                    onChange={e => setForm({ ...form, [f]: e.target.value })} />
                </div>
              ))}
              <div className="modal-footer">
                <button type="button" className="btn btn--ghost" onClick={closeModal}>Cancel</button>
                <button type="submit" className="btn btn--primary" disabled={saving}>{saving ? 'Saving…' : 'Save'}</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
